import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createCrmEndorsementsSlice = (set, get) => ({
    crmEndorsements: {
        loading: false,
        data: []
    },
    getCrmEndorsements: async (insuranceRequestId) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ crmEndorsements: { ...state.crmEndorsements, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/crm/insurance/${insuranceRequestId}/endorsements`,
                headers: { token }
            });
            set(state => ({ crmEndorsements: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ crmEndorsements: { loading: false, data: [] } }));
        }
    }
});
